import { render, staticRenderFns } from "./DAModal.vue?vue&type=template&id=33bbf22c"
import script from "./DAModal.vue?vue&type=script&lang=js"
export * from "./DAModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports